// export function urlBase64ToUint8Array(base64String) {
//     const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
//     const base64 = (base64String + padding)
//         .replace(/-/g, "+")
//         .replace(/_/g, "/");
//
//     const rawData = window.atob(base64);
//     const outputArray = new Uint8Array(rawData.length);
//
//     for (let i = 0; i < rawData.length; ++i) {
//         outputArray[i] = rawData.charCodeAt(i);
//     }
//     return outputArray;
// }

import moment from 'moment'
import { ASSIGNEE_TYPE } from './constants'
import { apiUrl, apiUrlTruc } from '../config'

export function getNameInCapitalize(string) {
  if (!string) return ''
  return string.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase())
}

export function urlify(text) {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '" target="_blank">' + url + '</a>'
  })
}

export const renderTime = value => {
  return `${String(moment(value).hour()).padStart(2, '0')}:${String(
    moment(value).minute()
  ).padStart(2, '0')}`
}

export const TextWrapUnread = props => (
  <div
    style={{
      display: 'block',
      fontWeight: 'bolder',
      wordWrap: 'break-word',
      wordBreak: 'break-all',
      width: props?.width || 100,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}>
    {props?.children}
  </div>
)

export const TextWrap = props => (
  <div
    style={{
      display: 'block',
      wordWrap: 'break-word',
      wordBreak: 'break-all',
      width: props?.width,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}>
    {props?.children}
  </div>
)

export const isIOSDevice = () => {
  const isPlatform = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ].includes(navigator.platform)

  const isAgent = navigator.userAgent.includes('Mac')

  return (
    // iPad on iOS 13 detection
    isPlatform || isAgent
  )
}

export const getExtensionFile = file_name => {
  if (!file_name) return ''
  return file_name.toLowerCase().split('.').pop()
}

export const findLeader = els => {
  if (!els) return
  return els.filter(el => el.permission === ASSIGNEE_TYPE.LEADER)
}

export const findHandler = els => {
  if (!els) return
  return els.filter(el => el.permission === ASSIGNEE_TYPE.HANDLER)
}
export const findCombiner = els => {
  if (!els) return
  return els.filter(el => el.permission === ASSIGNEE_TYPE.COMBINER)
}
export const findFollower = els => {
  if (!els) return
  return els.filter(el => el.permission === ASSIGNEE_TYPE.FOLLOWER)
}
export const findCreater = els => {
  if (!els) return
  return els.filter(el => el.permission === ASSIGNEE_TYPE.CREATE)
}

/** Check nullish */
export const isNullish = value => {
  return value === undefined || value === null || value === ''
}
export const findViewFile = (file, fileId, fileType, fileName) => {
  const isUBQLV = window.location.pathname.includes(
    'connected-committee-document'
  )
  const isFileTruc = window.location.pathname.includes('messages')

  const isPDF = ['pdf'].includes(fileType)

  const isFileVIMCToTruc =
    window.location.pathname.includes('connected-document')
  const isLTVBNV = window.location.pathname.includes(
    'internal-connected-document'
  )
  const isImageAndPDF =
    file?.type === 'application/pdf' ||
    [
      'jpg',
      'bmp',
      'dib',
      'jpe',
      'jfif',
      'gif',
      'tif',
      'tiff',
      'png',
      'heic',
      'pdf',
    ].includes(fileType)
  let viewFile = null

  if (isIOSDevice() && (isPDF || isUBQLV || isLTVBNV)) {
    if (isPDF) {
      if (isFileTruc) {
        viewFile = `${apiUrl}/api/v1/truc-upload/view/${fileId}?fileName=${fileName}`
      } else {
        if (isLTVBNV) {
          viewFile = `${apiUrl}/api/v1/images/${fileId}`
        } else {
          viewFile = `${
            isFileVIMCToTruc ? apiUrlTruc : apiUrl
          }/api/v1/images/${fileId}`
        }
      }
    }
    if (isUBQLV) {
      viewFile = file
    }
  } else {
    if (isImageAndPDF) {
      if (fileId) {
        if (isFileTruc) {
          viewFile = `${apiUrl}/api/v1/truc-upload/view/${fileId}?fileName=${fileName}`
        } else {
          if (isLTVBNV) {
            viewFile = `${apiUrl}/api/v1/images/${fileId}`
          } else {
            viewFile = `${
              isFileVIMCToTruc ? apiUrlTruc : apiUrl
            }/api/v1/images/${fileId}`
          }
        }
      } else {
        viewFile = URL.createObjectURL(file) /** View file UBQLV */
      }
    } else {
      if (isFileTruc) {
        viewFile = `https://view.officeapps.live.com/op/embed.aspx?src=${apiUrl}/api/v1/truc-upload/view/${fileId}?fileName=${fileName}`
      } else {
        viewFile = `https://view.officeapps.live.com/op/embed.aspx?src=${
          isFileVIMCToTruc ? apiUrlTruc : apiUrl
        }/api/v1/images/${fileId}`
      }
    }
  }
  return viewFile
}

export const removeHtml = string => {
  if (!string) return ''
  return string
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, '')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/, '<')
    .replace(/&gt;/, '>')
    .replace(/&le;/, '≤')
    .replace(/&ge;/, '≥')
}
